import blog from 'app/entities/blog/blog.reducer';
import importantUserDetails from 'app/entities/important-user-details/important-user-details.reducer';
import supplementCategories from 'app/entities/supplement-categories/supplement-categories.reducer';
import supplements from 'app/entities/supplements/supplements.reducer';
import planCategory from 'app/entities/plan-category/plan-category.reducer';
import plans from 'app/entities/plans/plans.reducer';
import transactionDetails from 'app/entities/transaction-details/transaction-details.reducer';
import productDeliveryStatus from 'app/entities/product-delivery-status/product-delivery-status.reducer';
import userPurchasedPlans from 'app/entities/user-purchased-plans/user-purchased-plans.reducer';
import userPurchasedSupplements from 'app/entities/user-purchased-supplements/user-purchased-supplements.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const entitiesReducers = {
  blog,
  importantUserDetails,
  supplementCategories,
  supplements,
  planCategory,
  plans,
  transactionDetails,
  productDeliveryStatus,
  userPurchasedPlans,
  userPurchasedSupplements,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
};

export default entitiesReducers;
